<template>
  <div
    class="
      cbg-white-container
      input-container
      theme--light
      v-card
      p-16
      border-card
    "
  >
    <v-row>
      <v-col cols="12" md="3">
        <label for>Search by Saathi code</label>
        <input
          class="form-control"
          v-model="saathiCode"
          placeholder="Saathi code"
          @input="debounceSearch()"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="table-div overflow-auto">
          <table class="table">
            <thead>
              <tr class="table-success">
                <th>Sathi Code</th>
                <th>Onboarded user count</th>
                <th>Subscription count</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="saathiDetail in saathiDetails" :key="saathiDetail._id">
                <td>{{ saathiDetail._id }}</td>
                <td>{{ saathiDetail.onboarded_user_count }}</td>
                <td>{{ saathiDetail.subscription_count }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-col>
    </v-row>
    <pagination
      v-if="!isEmpty"
      class="mx-6"
      :currentPage="page"
      :recordPerPage="recordsPerPage"
      :total="total"
      @changePage="changePage"
    />
  </div>
</template>
<script>
import config from "@/config.js";
import debounce from "lodash/debounce";
export default {
  data() {
    return {
      saathiDetails: [],
      saathiCode: null,
      page: 1,
      recordsPerPage: 10,
      total: 0,
      isEmpty: true,
    };
  },
  components: {
    pagination: () => import("@/views/common/Pagination"),
  },
  methods: {
    debounceSearch: debounce(function () {
      this.getSaathiDetails();
    }, 500),
    changePage(page) {
      console.log(page);
      this.page = page.currentPage;
      this.getSaathiDetails();
    },
    getSaathiDetails() {
      let params = {
        saathi_code: this.saathiCode,
        records_per_page: this.recordsPerPage,
        page: this.page,
      };
      let url = `${config.BASE_URL}api/v2/admin/seva-details`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          if (response.body.data.total > 0) this.isEmpty = false;
          this.page = response.body.data.page;
          this.recordsPerPage = response.body.data.limit;
          this.total = response.body.data.count;
          this.saathiDetails = response.body.data.list;
        }
      });
    },
  },
  mounted() {
    this.getSaathiDetails();
  },
};
</script>